import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { EnvironmentService } from 'src/services/environment/environment.service';
import { EProductType } from 'src/shared/types/product-type';

interface IBrandingHeadConfig {
    title: string;
    icon: { href: string; type?: string };
}

const BRANDING_HEAD_CONFIG: Record<EProductType, IBrandingHeadConfig> = {
    [EProductType.Wrike]: {
        title: 'Wrike',
        icon: { href: 'favicon.ico?v8', type: 'image/x-icon' },
    },
    [EProductType.Klaxoon]: {
        title: 'Klaxoon',
        icon: { href: 'https://cdn.klaxoon.com/image/__cdnu/logo_favicon_v2.svg', type: 'image/png' },
    },
};

@Injectable({ providedIn: 'root' })
export class BrandingHeadService {
    private readonly document = inject<Document>(DOCUMENT);
    private readonly title = inject(Title);
    private readonly environmentService = inject(EnvironmentService);

    public init(): void {
        const product = this.environmentService.environment.productType;
        const config = BRANDING_HEAD_CONFIG[product];
        if (!config) {
            return;
        }

        this.title.setTitle(config.title);
        this.setOrUpdateFavicon(config.icon.href, config.icon.type);
    }

    private setOrUpdateFavicon(href: string, type?: string): void {
        let linkEl = this.document.querySelector('link[rel="icon"]') as HTMLLinkElement | null;

        if (!linkEl) {
            linkEl = this.document.createElement('link');
            linkEl.rel = 'icon';
            this.document.head.appendChild(linkEl);
        }

        if (type) {
            linkEl.setAttribute('type', type);
        } else {
            linkEl.removeAttribute('type');
        }

        if (!linkEl.href.includes(href)) {
            linkEl.href = href;
        }
    }
}
